import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-trasaction-modal',
  templateUrl: './trasaction-modal.component.html',
  styleUrls: ['./trasaction-modal.component.scss'],
})
export class TrasactionModalComponent implements OnInit {

  @Input () isFrom:string;
  @Input() isHomeClub: boolean;
  constructor(private mdlCtrl:ModalController) { }

  ngOnInit() {}

  cancel(){
    this.mdlCtrl.dismiss();
  }

  saveChanges(data:string){
    this.mdlCtrl.dismiss(data);
  }

}
